export const CLIENT_STATE_KEYS = [
  "new",
  "active",
  "recurrent",
  "vip",
  "atRisk",
  "lost",
] as const;

export type ClientStateKey = (typeof CLIENT_STATE_KEYS)[number];
export type TransitionType = "advance" | "decline" | "recovery";
